import { render, staticRenderFns } from "./LecturerList.vue?vue&type=template&id=4b136770&scoped=true"
import script from "./LecturerList.vue?vue&type=script&lang=js"
export * from "./LecturerList.vue?vue&type=script&lang=js"
import style0 from "./LecturerList.vue?vue&type=style&index=0&id=4b136770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b136770",
  null
  
)

export default component.exports